// src/pages/Home.jsx
import React, { useEffect, useState } from "react";
import Navbar from "../../Components/Navbar/index.tsx";
import SecurityServicesCarousel from "../../Components/ServicesCarousel/index.tsx"; // Adjust path accordingly
import "./style.css";
import Services from "../../Components/Services/index.tsx";
import hero from "../../Assets/Home/hero.jpg";
import hero1 from "../../Assets/Home/hero1.jpg";
import hero2 from "../../Assets/Home/hero2.jpeg";
import phone from "../../Assets/Home/phone.png";
import { useNavigate } from "react-router-dom";
import quotes from "../../Assets/Home/quotes.png";
import Footer from "../../Components/Footer/index.tsx";
import client1 from "../../Assets/Clients/client1.png";
import client2 from "../../Assets/Clients/client2.png";
import client3 from "../../Assets/Clients/client3.png";
import client4 from "../../Assets/Clients/client4.png";
import client5 from "../../Assets/Clients/client5.png";
import client6 from "../../Assets/Clients/client6.png";
import client7 from "../../Assets/Clients/client7.png";
import client8 from "../../Assets/Clients/client8.png";
import client9 from "../../Assets/Clients/client9.png";
import client10 from "../../Assets/Clients/client10.png";
import client11 from "../../Assets/Clients/client11.png";
import client12 from "../../Assets/Clients/client12.png";
import client13 from "../../Assets/Clients/client13.png";
import client14 from "../../Assets/Clients/client14.png";
import rev1 from "../../Assets/Clients/rev1.png";
import rev2 from "../../Assets/Clients/rev2.png";
import rev3 from "../../Assets/Clients/rev3.png";
import rev4 from "../../Assets/Clients/rev4.png";
import rev5 from "../../Assets/Clients/rev5.png";
import rev6 from "../../Assets/Clients/rev6.png";
import rev7 from "../../Assets/Clients/rev7.png";
import rev8 from "../../Assets/Clients/rev8.png";
import rev9 from "../../Assets/Clients/rev9.png";
import ChatBot from "../../Components/Chatbot/index.tsx";
import FreightConsult from "../../Components/WhyUs/index.tsx";
import gold from "../../Assets/Home/gold1.jpeg";

const Home = () => {
  const navigate = useNavigate();
  const images = [hero, hero1, hero2];
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === images.length - 1 ? 0 : prevIndex + 1
      );
    }, 3000); // Change image every 3 seconds

    return () => clearInterval(interval); // Cleanup
  }, [images.length]);

  const testimonials = [
    {
      name: "Deepan Ron",
      title: "Condominium Manager, The Criterion",
      icon: quotes,
      image: rev9,
      review:
        "Outstanding service and unwavering dedication from the Singapore Security Force. Whether in routine patrols or emergency response, they’ve shown vigilance, discipline, and excellence.",
    }
    ,

    {
      name: "James Yeo",
      title: "Secretary",
      icon: quotes,
      image: rev1,
      review:
        "Reliable and professional team. Easy to communicate with, and the quality of work is excellent. Great coordination with our management agent.",
    },
    {
      name: "Emma",
      title: "Residential Manager",
      icon: quotes,
      image: rev2,
      review:
        "Very satisfied with the service. Easy to work with, proactive, and always bringing new ideas. Officers are professional and do an outstanding job",
    },
    {
      name: "Andy Goh",
      title: "Residential Manager",
      icon: quotes,
      image: rev3,
      review:
        "Appreciation for an excellent job! Thanks to your leadership, dedication, and your team’s energy and teamwork, we’re enjoying the results. SSF is a great source of pride.",
    },
    // {
    //   name: "Emma Ambrose",
    //   title: "Condominium Manager",
    //   icon: quotes,
    //   image: rev4,
    //   review:
    //     "I sincerely appreciate the exceptional performance by SSF. The team delivers high-quality results with a smooth process and consistently high standards.",
    // },
    {
      name: "Robin Leow",
      title: "Managing Director",
      icon: quotes,
      image: rev5,
      review:
        "Your team’s professionalism and dedication have made a strong impact. Truly appreciated!",
    },
    {
      name: "Eddy Laurence ",
      title: "Executive Officer",
      icon: quotes,
      image: rev6,
      review:
        "Great team performance! No manpower shortages to date, and the ops team is always eager to assist. SSF has surpassed our expectations—we're very satisfied with their responsive service.",
    },

    {
      name: "Sunny ",
      title: "Condominium Manager",
      icon: quotes,
      image: rev7,
      review:
        "The officer on duty has been exceptionally vigilant, attentive, and professional, significantly positively impacting the estate. Your responsiveness and unwavering commitment have played a vital role, and we highly value your partnership.",
    },
    {
      name: "Tham Ying Quan",
      title: "Rhodo Operation Manager",
      icon: quotes,
      image: rev4,
      review:
        "We sincerely commend your day and night shift security officers for their professionalism, vigilance, and service excellence. Their dedication to access control, resident assistance, emergency response, and incident reporting has significantly contributed to a safe and welcoming environment at Twin Vew. Thank you for your outstanding service.",
    },
    {
      name: "Rejani",
      title: "Site Manager",
      icon: quotes,
      image: rev8,
      review:
        "Our security team has been praised for their professionalism, reliability, and friendly service. Their prompt response and dedication ensure a safe and welcoming environment for all residents.",
    },
  ];

  return (
    <>
      <Navbar />
      <div></div>
      <section className="security-section-web">
        <div className="hero-image-wrapper-web">
          <img
            className="hero-image-web"
            src={images[currentIndex]}
            alt="security company"
          />
          <div className="hero-image-overlay-web"></div>

          <div className="hero-content-web">
            <h1 className="hero-content-web-hea">
              BEST SECURITY COMPANY IN SINGAPORE
            </h1>
            <p>
              When it comes to safety, trust is everything. At Singapore
              Security Force, we are proud to be recognized as one of the most
              trusted security companies in Singapore
            </p>
            <div onClick={() => navigate("/about-us")} className="button">
              <span className="button__icon-wrapper">
                <svg
                  viewBox="0 0 14 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="button__icon-svg"
                  width="10"
                >
                  <path
                    d="M13.376 11.552l-.264-10.44-10.44-.24.024 2.28 6.96-.048L.2 12.56l1.488 1.488 9.432-9.432-.048 6.912 2.304.024z"
                    fill="currentColor"
                  ></path>
                </svg>

                <svg
                  viewBox="0 0 14 15"
                  fill="none"
                  width="10"
                  xmlns="http://www.w3.org/2000/svg"
                  className="button__icon-svg button__icon-svg--copy"
                >
                  <path
                    d="M13.376 11.552l-.264-10.44-10.44-.24.024 2.28 6.96-.048L.2 12.56l1.488 1.488 9.432-9.432-.048 6.912 2.304.024z"
                    fill="currentColor"
                  ></path>
                </svg>
              </span>
              About Us
            </div>
          </div>
        </div>
      </section>
      <section className="security-section-mobile">
        <div className="security-content">
          <div className="security-left">
            <div className="hero-image-wrapper">
              <img
                className="hero-image"
                src={images[currentIndex]}
                alt="Singapore Security Company"
              />
              <div className="hero-image-overlay"></div>
            </div>
          </div>
          <div className="security-right">
            <h1 className="hero-content-web-hea">
              BEST SECURITY COMPANY IN SINGAPORE
            </h1>
            <p>
              When it comes to safety, trust is everything. At Singapore
              Security Force, we are proud to be recognized as one of the most
              trusted security companies in Singapore
            </p>

            <div onClick={() => navigate("/about-us")} className="button">
              <span className="button__icon-wrapper">
                <svg
                  viewBox="0 0 14 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="button__icon-svg"
                  width="10"
                >
                  <path
                    d="M13.376 11.552l-.264-10.44-10.44-.24.024 2.28 6.96-.048L.2 12.56l1.488 1.488 9.432-9.432-.048 6.912 2.304.024z"
                    fill="currentColor"
                  ></path>
                </svg>

                <svg
                  viewBox="0 0 14 15"
                  fill="none"
                  width="10"
                  xmlns="http://www.w3.org/2000/svg"
                  className="button__icon-svg button__icon-svg--copy"
                >
                  <path
                    d="M13.376 11.552l-.264-10.44-10.44-.24.024 2.28 6.96-.048L.2 12.56l1.488 1.488 9.432-9.432-.048 6.912 2.304.024z"
                    fill="currentColor"
                  ></path>
                </svg>
              </span>
              About Us
            </div>
          </div>
        </div>
      </section>

      <section className="services-carousel-section">
        <Services />

      </section>
      <section className="services-carousel-section">
        <SecurityServicesCarousel />
      </section>

      <section className="our-customers text-center py-5">
        <div className="container">
          <h2 className="fw-bold mb-3">Our Valued Customers</h2>
          <p className="text-muted mb-5">
            Trusted by leaders across industries to protect what matters most.
          </p>
          <div className="row justify-content-evenly align-items-center  g-5">
            {[
              { name: "Zoom", src: client1 },
              { name: "", src: client2 },
              { name: "", src: client3 },
              { name: "", src: client4 },
              { name: "", src: client5 },
              { name: "", src: client6 },
              { name: "", src: client7 },
              { name: "", src: client8 },
              { name: "", src: client9 },
              { name: "", src: client10 },
              { name: "", src: client11 },
              { name: "", src: client12 },
              { name: "", src: client13 },
              { name: "", src: client14 },
            ].map((client, idx) => (
              <div className="col-6 col-sm-3" key={idx}>
                <img
                  src={client.src}
                  alt={client.name}
                  className="img-fluid brand-logo"
                />
              </div>
            ))}
          </div>
          {/* <p className="text-muted mt-4">And 50+ Other Clients Who we have Worked with...</p> */}
        </div>
      </section>

      <section>
        <div className="testimonial-container">
          <div className="testimonial-header">
            <h2 className="testimonial-title">What our Clients Say?</h2>
          </div>

          <div className="testimonial-grid">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="testimonial-card">
                <div className="testimonial-image-wrapper">
                  <img
                    className="testimonial-image"
                    src={testimonial.image}
                    alt={testimonial.name}
                  />
                </div>
                <img
                  className="testimonial-icon"
                  src={testimonial.icon}
                  alt={testimonial.name}
                />
                <blockquote>
                  <p className="testimonial-review">"{testimonial.review}"</p>
                </blockquote>
                <div className="testimonial-info">
                  <p className="testimonial-name">{testimonial.name}</p>
                  <p className="testimonial-title-text">{testimonial.title}</p>
                  <div className="testimonial-stars">★★★★★</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section className="why-choose-us">
        <div className="container-hero-tagline ">
          <p>Security With</p>
          <section className="animation">
            <div className="first">
              <div>Smart moves</div>
            </div>
            <div className="second">
              <div>Sharp eyes</div>
            </div>
            <div className="third">
              <div>balance</div>
            </div>
            <div className="fourth">
              <div>boldness</div>
            </div>
          </section>
        </div>
        <div
          style={{
            width: "100vw", // full screen width
            height: "700px", // adjust height as needed
            backgroundImage: `url(${gold})`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <FreightConsult />
        </div>
      </section>
      <section className="consultation-section">
        <div className="consultation-content">
          <h2>Get Free Consultation</h2>
          <p className="phone-number">
            <img src={phone} alt="phone" />
            Call Us : 8215 0399
          </p>
          <h3 className="hea-services">Interested in Working With Us?</h3>
          <div className="button-container">
            <button className="res-btn" onClick={() => navigate("/career")}>
              <div className="svg-wrapper-1">
                <div className="svg-wrapper">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="24"
                    height="24"
                  >
                    <path fill="none" d="M0 0h24v24H0z"></path>
                    <path
                      fill="currentColor"
                      d="M1.946 9.315c-.522-.174-.527-.455.01-.634l19.087-6.362c.529-.176.832.12.684.638l-5.454 19.086c-.15.529-.455.547-.679.045L12 14l6-8-8 6-8.054-2.685z"
                    ></path>
                  </svg>
                </div>
              </div>
              <span>Send Your CV</span>
            </button>
          </div>
        </div>


      </section>
      <ChatBot />

      <Footer />
    </>
  );
};

export default Home;
